import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { User } from '@/generated/graphql';
import { LoginForm } from '@/components/LoginForm';
import { AppNav } from '@/components/AppNav';
import { HOME_ROUTES } from './consts';
import { LogoutButton } from '@/components/LogoutButton';
import { Footer } from '@/components/Footer';

export function Login() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { user } = useAuth();

  const onLoginSuccess = async ({ user }: { user: User }) => {
    // check for redirect param
    const redirect = searchParams.get('redirect');
    if (redirect) {
      navigate(redirect);
    } else {
      navigate(HOME_ROUTES[user?.role || 'USER']);
    }
  };

  return (
    <div className="flex min-h-screen flex-col">
      <AppNav />
      <div
        className={`relative z-[2] mx-auto flex max-w-screen-md flex-1 flex-col items-center justify-center`}
      >
        {user ? (
          <div>
            <h1 className="mb-4 text-xl">
              Logged in as {user.name || user.username || user.email}
            </h1>
            <LogoutButton />
          </div>
        ) : (
          <LoginForm onLoginSuccess={onLoginSuccess} />
        )}
      </div>
      <Footer />
    </div>
  );
}
